export default "__VITE_ASSET__BX$6IMff__"